﻿export class ImageLoader {
  // все изображения новостей
  images: HTMLImageElement[];

  // интервал обработки изображений
  intervalId: number;

  constructor() {
    // инициализация всеx изображения новостей
    this.images = Array.prototype.slice.call(document.querySelectorAll<HTMLImageElement>('img.corp-news-list__item__image'));
    this.intervalId = setInterval(this.newsImageLoadingHandler.bind(this), 200);
  }
	/**
   * Функция для обработки незагруженных изображений
   * Когда все изображения загрузятся, то интервал чистится
   * @param images - изображения со страницы
   * @param interval - интервал обработки
  */
  newsImageLoadingHandler() {
    if (this.images.length === 0) {
      clearInterval(this.intervalId);
      return
    }
    this.images.forEach((image, index) => {
      if (!image.complete) {
        return
      }
      image.style.display = 'block';
      const next: HTMLElement = image.parentElement.querySelector('.corp-news-list__item__image--loader') as HTMLElement;
      next.style.display = 'none';
      this.images.splice(index, 1);
    })
  }
}
